import { EventBus } from "../event-bus";
import axios from "axios";

export default {
    import(self) {
        let formData = new FormData();
        formData.append("file", self.file);
        formData.append('type', self.type);
        formData.append("isTemporary", true);

        const donorService = this;

        self.isImportProcessed = true;
        self.isImportFail = false;

        axios.post("/donors/import", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then(function (response) {
                const div = document.createElement("div");
                if (response.data) {
                    div.innerHTML = response.data.htmlMessage;
                }
                else {
                    div.innerHTML = self.$t('Ошибка соединения');
                }
                self.$swal({
                    title: self.$t('Результаты проверки'),
                    content: div,
                    className: 'swal-donors-import-check',
                    icon: "success",
                    buttons: {
                        ok: {
                            className: "btn-primary",
                            text: self.$t('Выполнить импорт'),
                            value: "ok"
                        },
                        copy: {
                            className: "btn-secondary",
                            text: self.$t('Скопировать текст'),
                            value: "copy"
                        },
                        cancel: self.$t('Отказаться')
                    }
                }).then(value => {
                    switch (value) {
                        case "ok":
                            donorService.realUpload(self);
                            break;
                        case "cancel":
                            self.isImportProcessed = false;
                            break;
                        case "copy":
                            self.$copyText(response.data.message)
                                .then(function () {
                                    self.$swal("", self.$t('Текст скопирован'), "success");
                                },
                                    function () {
                                        self.$swal("", self.$t('Ошибка при копировании текста'), "warning");
                                    });
                            break;
                    }
                });
                self.isImportProcessed = false;
            })
            .catch(function (response) {
                const div = document.createElement("div");

                div.innerHTML = response.data.htmlMessage;
                self.$swal({
                    title: self.$t('Предупреждение'),
                    content: div,
                    icon: "warning",
                    buttons: {
                        ok: "Ok",
                        copy: {
                            text: self.$t('Скопировать')
                        }
                    }
                }).then(value => {
                    switch (value) {
                        case "ok":
                            window.location.reload();
                            break;
                        case "copy":
                            self.$copyText(response.data.message)
                                .then(function () {
                                    self.$swal("", self.$t('Текст скопирован'), "success");
                                },
                                    function () {
                                        self.$swal("", self.$t('Ошибка при копировании текста'), "warning");
                                    });
                            break;
                    }
                });
                self.isImportProcessed = false;
            });
    },
    realUpload(self) {
        self.isImportProcessed = true;
        let formData = new FormData();

        formData.append("isTemporary", false);
        formData.append('type', self.type);
        self.isFileCheck = false;
        axios.post("/donors/import", formData)
            .then(function (response) {
                self.hideModal();
                self.isImportProcessed = false;
                const div = document.createElement("div");
                if (response.data) {
                    div.innerHTML = response.data.htmlMessage;
                } else {
                    div.innerHTML = self.$t('Ошибка соединения');
                }
                self.$swal({
                    title: self.$t('Успешный импорт'),
                    content: div,
                    icon: "success"
                }).then(() => {
                    self.isImportProcessed = false;
                    window.location.reload();
                });
            })
            .catch(function (response) {
                const div = document.createElement("div");
                div.innerHTML = response.data.htmlMessage;
                self.$swal({
                    title: self.$t('Предупреждение'),
                    content: div,
                    icon: "warning",
                    buttons: {
                        ok: "Ok",
                        copy: {
                            text: self.$t('Скопировать')
                        }
                    }
                }).then(value => {
                    switch (value) {
                        case "ok":
                            self.isImportProcessed = false;
                            break;
                        case "copy":
                            self.isImportProcessed = false;
                            self.$copyText(response.data.message)
                                .then(function () {
                                    self.$swal("", self.$t('Текст скопирован'), "success");
                                },
                                    function () {
                                        self.$swal("", self.$t('Ошибка при копировании текста'), "warning");
                                    });
                            break;
                    }
                });
            });
    },
    loadCollectionCenters(self) {
        EventBus.$emit("showThrobber");
        axios
            .get("/Dictionary/GetCollectionCenters")
            .then(response => {
                self.collectionCenters = response.data;
                self.isImportProcessed = false;
            })
            .catch(w => {
                self.isImportProcessed = false;
            }).finally(() => EventBus.$emit("hideThrobber"));
    }
}
